import { type ethers } from "ethers";
import { type GasObjectType } from "../gas";

type TransactionType = {
  to: string;
  chainId: number;
  nonce?: number;
  from?: string;
  data?: string;
  value?: bigint;
  gasLimit?: bigint;
};

export const makeTransaction = (tx: TransactionType) => {
  if (!tx.from) {
    throw new Error("tx.from is required");
  }

  const txRequest = {
    chainId: tx.chainId,
    nonce: tx.nonce,
    data: tx.data ?? "0x",
    gasLimit: tx.gasLimit ?? 200_000n,
    from: tx.from,
    to: tx.to,
    value: tx.value ?? 0n,
  };

  return txRequest;
};

export const sendEOATransactionWithGasObject = async (
  signer: ethers.Signer,
  tx: ethers.TransactionRequest,
  gasObject?: GasObjectType,
) => {
  const txRequest = {
    ...tx,
    ...gasObject,
  };

  const txResponse = signer.sendTransaction(txRequest);

  return txResponse;
};
